import script from "./ButtonPlus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonPlus.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonPlus.vue?vue&type=style&index=0&id=5926e10b&scoped=true&lang=css"
import "./ButtonPlus.vue?vue&type=style&index=1&id=5926e10b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5926e10b"]])

export default __exports__